<template>
  <div class="page__empty" v-if="show">
    <h2 class="subheading grey--text">
      {{ message }}
      <v-icon color="orange">directions_walk</v-icon>
      <v-icon color="red">directions_run</v-icon>
    </h2>
  </div>
</template>
<script>
export default {
  name: "EmptyMessage",
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    message: {
      type: String,
      default: "No data found.",
    },
  },
};
</script>

<style>
.page__empty {
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>
